import { jsx as e } from "react/jsx-runtime";
import n from "@jetbrains/ring-ui-built/components/link/link.js";
const t = {
  target: "_blank",
  rel: "noopener noreferrer"
}, l = (r) => /* @__PURE__ */ e(n, { title: "Open external resource", ...r, ...t });
export {
  t as EXTERNAL_LINK_PARAMETERS,
  l as ExternalLink
};
